import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Link,
  Typography,
  IconButton,
  Stack,
  Divider,
} from '@mui/material';
import {
  Facebook as FacebookIcon,
  Language as LanguageIcon,
  Instagram as InstagramIcon,
} from '@mui/icons-material';

const Footer = () => {
  const footerLinks = {
    'La Yoga Yourte du Luberon': [
      { title: 'A propos de moi', path: 'https://yogamelieluberon.fr/qui-suis-je/', external: true },
      { title: 'Contactez-moi', path: '/contact' },
      { title: 'Avis', path: 'https://yogamelieluberon.fr/les-temoignages-2/', external: true },
      { title: 'La Yoga Yourte', path: 'https://yogamelieluberon.fr/la-yoga-yourte-du-luberon/', external: true },
    ],
    'Activités': [
      { title: 'Les cours de Yoga', path: 'https://yogamelieluberon.fr/les-cours-2/', external: true },
      { title: 'Le Shiatsu', path: 'https://yogamelieluberon.fr/le-shiatsu/', external: true },
      { title: 'Séjours à la Yourte', path: 'https://yogamelieluberon.fr/sejours-a-la-yourte/', external: true },
      { title: 'Louer la Yourte', path: 'https://yogamelieluberon.fr/lo/', external: true },
    ],
  };

  const socialLinks = [
    { icon: <FacebookIcon />, url: 'https://www.facebook.com/layogayourteduluberon' },
    { icon: <LanguageIcon />, url: 'https://yogamelieluberon.fr/' },
    { icon: <InstagramIcon />, url: 'https://www.instagram.com/yogayourteduluberon/' },
  ];

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.default',
        py: { xs: 6, md: 10 },
        position: 'relative',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Stack spacing={2}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 800,
                  color: 'primary.main',
                }}
              >
                Planning de La Yoga Yourte du Luberon
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ maxWidth: 400 }}
              >
                Découvrez des cours de Yoga et soins holistiques dans votre région.
                Connectez-vous avec des personnes partageant vos centres d’intérêt et
                profitez pleinement de votre temps libre.
              </Typography>
              <Stack direction="row" spacing={1}>
                {socialLinks.map((social, index) => (
                  <IconButton
                    key={index}
                    component="a"
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: 'text.secondary',
                      '&:hover': {
                        color: 'primary.main',
                      },
                    }}
                  >
                    {social.icon}
                  </IconButton>
                ))}
              </Stack>
            </Stack>
          </Grid>

          {/* Links Sections */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <Grid item xs={12} sm={6} md={2} key={category}>
              <Typography
                variant="subtitle1"
                color="text.primary"
                sx={{ mb: 2, textTransform: 'capitalize' }}
              >
                {category}
              </Typography>
              <Stack spacing={1.5}>
                {links.map((link) => (
                  <Link
                    key={link.title}
                    component={link.external ? 'a' : RouterLink}
                    to={!link.external ? link.path : undefined}
                    href={link.external ? link.path : undefined}
                    target={link.external ? '_blank' : undefined}
                    rel={link.external ? 'noopener noreferrer' : undefined}
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      '&:hover': {
                        color: 'primary.main',
                      },
                    }}
                  >
                    {link.title}
                  </Link>
                ))}
              </Stack>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 6 }} />

        {/* Copyright */}
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Escale Stratégie. Tous droits réservés.
          </Typography>
          <Stack direction="row" spacing={3}>
            
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer; 